import { ADD_MAX_CAP_FAILURE, ADD_MAX_CAP_REQUEST, ADD_MAX_CAP_RESET, ADD_MAX_CAP_SUCCESS } from "redux/actions/action-type";

const initialState = {
    isAddLoading: false,
    isAddSuccess: false,
    isAddFail: false,
    addMaxCapResponse: {},
};

export const addMaxCapReducer = (state = initialState, { type, addMaxCapResponse }) => {
    switch (type) {
        case ADD_MAX_CAP_REQUEST:
            return {
                ...state,
                isAddLoading: true,
                isAddSuccess: false,
                isAddFail: false,
            };
        case ADD_MAX_CAP_SUCCESS:
            return {
                ...state,
                addMaxCapResponse: addMaxCapResponse,
                isAddLoading: false,
                isAddSuccess: true,
                isAddFail: false,
            };
        case ADD_MAX_CAP_FAILURE:
            return {
                ...state,
                addMaxCapResponse: addMaxCapResponse,
                isAddLoading: false,
                isAddSuccess: false,
                isAddFail: true,
            };
        case ADD_MAX_CAP_RESET:
            return { ...initialState };
        default:
            return { ...state };
    }
};
